export const isAvailableForCommunity = (communityId: number): boolean => {
  if (!process.env.REACT_CAMERAS_RPI_COMMUNITY_WHITE_LIST) return false;
  return process.env.REACT_CAMERAS_RPI_COMMUNITY_WHITE_LIST.split(',').includes(communityId.toString());
};
